(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ordessa-clean-details"] && !Shopify.designMode) return;
  try {
    if (!window.ordessaCleanDetailsBound) {
    window.ordessaCleanDetailsBound = true;
    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('a[href="#ordessa-fit"]');
      var fit = document.querySelector('.ord-clean-details details#ordessa-fit');
      if (!link || !fit) return;
      fit.open = true;
      var summary = fit.querySelector('summary');
      if (summary) summary.focus({preventScroll: true});
    });
    window.addEventListener('hashchange', function() {
      if (window.location.hash !== '#ordessa-fit') return;
      var fit = document.querySelector('.ord-clean-details details#ordessa-fit');
      if (fit) fit.open = true;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ordessa-cookie-preferences"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('OrdessaCookiePreferences');
    if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const fields = dialog.querySelector('[data-consent-fields]');
    const status = dialog.querySelector('[data-consent-status]');
    const retry = dialog.querySelector('[data-consent-retry]');
    const names = ['preferences', 'marketing', 'analytics'];
    const allowedMethods = {
      preferences: 'preferencesProcessingAllowed',
      marketing: 'marketingAllowed',
      analytics: 'analyticsProcessingAllowed'
    };
    const inputs = Object.fromEntries(names.map(name => [name, fields.querySelector(`[name="${name}"]`)]));
    let api;
    let baseline = {};
    let opener;
    let generation = 0;
    let pending = false;

    function usable(value) {
      return value && ['currentVisitorConsent', 'setTrackingConsent', ...Object.values(allowedMethods)]
        .every(name => typeof value[name] === 'function');
    }

    function loadApi() {
      if (usable(window.Shopify?.customerPrivacy)) return Promise.resolve(window.Shopify.customerPrivacy);
      return new Promise((resolve, reject) => {
        if (typeof window.Shopify?.loadFeatures !== 'function') return reject(new Error('unavailable'));
        let settled = false;
        const timer = setTimeout(() => {
          if (!settled) { settled = true; reject(new Error('timeout')); }
        }, 10000);
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            if (error || !usable(window.Shopify.customerPrivacy)) reject(new Error('unavailable'));
            else resolve(window.Shopify.customerPrivacy);
          });
        } catch (error) {
          settled = true;
          clearTimeout(timer);
          reject(error);
        }
      });
    }

    function displayCurrent() {
      api.currentVisitorConsent();
      names.forEach(name => {
        baseline[name] = api[allowedMethods[name]]() === true;
        inputs[name].checked = baseline[name];
      });
    }

    async function prepare() {
      const current = ++generation;
      pending = false;
      fields.disabled = true;
      retry.hidden = true;
      dialog.setAttribute('aria-busy', 'true');
      status.textContent = dialog.dataset.loading;
      try {
        const loaded = await loadApi();
        if (current !== generation || !dialog.open) return;
        api = loaded;
        displayCurrent();
        fields.disabled = false;
        status.textContent = '';
      } catch (error) {
        if (current !== generation || !dialog.open) return;
        status.textContent = dialog.dataset.error;
        retry.hidden = false;
      } finally {
        if (current === generation) dialog.setAttribute('aria-busy', 'false');
      }
    }

    function save(payload) {
      if (pending || fields.disabled || !api) return;
      if (!Object.keys(payload).length) {
        status.textContent = dialog.dataset.unchanged;
        return;
      }
      const current = generation;
      pending = true;
      fields.disabled = true;
      retry.hidden = true;
      dialog.setAttribute('aria-busy', 'true');
      status.textContent = dialog.dataset.saving;
      let settled = false;
      const finish = error => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (current !== generation || !dialog.open) return;
        pending = false;
        dialog.setAttribute('aria-busy', 'false');
        let verified = false;
        try {
          const consent = api.currentVisitorConsent();
          verified = !error && Object.entries(payload).every(([name, value]) => consent[name] === (value ? 'yes' : 'no'));
          if (verified) displayCurrent();
        } catch (readError) { verified = false; }
        fields.disabled = false;
        status.textContent = verified ? dialog.dataset.saved : dialog.dataset.saveError;
      };
      const timer = setTimeout(() => finish(), 12000);
      try {
        api.setTrackingConsent(payload, result => finish(result?.error));
      } catch (error) { finish(error); }
    }

    document.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!link || !link.closest('footer')) return;
      let destination;
      try { destination = new URL(link.href, window.location.href); } catch (error) { return; }
      if (destination.origin !== window.location.origin || destination.hash !== '#shopifyReshowConsentBanner') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (dialog.open) return;
      opener = link;
      dialog.showModal();
      prepare();
    }, true);

    dialog.querySelector('[data-consent-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      ++generation;
      pending = false;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    retry.addEventListener('click', prepare);
    dialog.querySelector('[data-consent-form]').addEventListener('submit', event => {
      event.preventDefault();
      const changes = {};
      names.forEach(name => {
        if (inputs[name].checked !== baseline[name]) changes[name] = inputs[name].checked;
      });
      save(changes);
    });
    dialog.querySelectorAll('[data-consent-all]').forEach(button => {
      button.addEventListener('click', () => {
        const value = button.dataset.consentAll === 'true';
        save(Object.fromEntries(names.map(name => [name, value])));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ordessa-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  function mountOrdessaWelcome() {
    'use strict';
    if (window.__ordessaWelcomeMounted) return;
    const root = document.getElementById('ordessa-welcome-root');
    if (!root) return;
    let config;
    try { config = JSON.parse(document.getElementById('ordessa-welcome-config').textContent); } catch (_) { root.remove(); return; }
    if (!Number.isFinite(config.discountPercent) || config.discountPercent <= 0 || config.discountPercent > 100 || config.currency !== 'AUD' || config.country !== 'AU' || (config.knownReturning && !config.preview)) { root.remove(); return; }
    window.__ordessaWelcomeMounted = true;
    const $ = id => document.getElementById(id);
    const cash = cents => 'A$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    const text = config.text;
    const offerReminder = () => text.reminder;
    const code = String(config.code || 'WELCOME10');
    const safePath = (value, fallback) => typeof value === 'string' && /^\/(?!\/)/.test(value) && !/[\\\u0000-\u001f]/.test(value) ? value : fallback;
    const rootUrl = safePath(config.rootUrl, '/').replace(/\/?$/, '/');
    function currentReturnPath() {
      return safePath(location.pathname + location.search + location.hash, rootUrl);
    }
    function updateDiscountLink() {
      const link = $('ow-discount-link');
      link.href = rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(currentReturnPath());
      const competing = hasCompetingDiscount();
      link.hidden = !!config.preview || applied();
      link.setAttribute('aria-disabled', String(competing));
      $('ow-apply-status').textContent = applied() ? text.applied : competing ? text.competing : '';
    }
    const isCartPage = /\/cart\/?$/.test(location.pathname);
    const isCheckout = /\/(checkouts?|thank_you)(\/|$)/.test(location.pathname);
    if (isCheckout) { root.remove(); return; }
    const storageKey = 'ordessaWelcome.v1.lastInvitation';
    let memoryStamp = 0;
    let lastFocus = null, termsFocus = null, termsFromWelcome = false;
    let activeDialog = null, cart = null, fetchBusy = false, refetchNeeded = false;
    let fetchTimer, placementTimer, autoTimer, autoOpened = false, pauseAutoUntil = 0;
    let hiddenOverflow = null;
    const previousInert = new Map();
    const emit = (action, surface) => document.dispatchEvent(new CustomEvent('ordessa:welcome', { detail: { action, surface, preview: !!config.preview } }));
    const readStamp = () => {
      let stored = memoryStamp;
      try { stored = Math.max(stored, Number(localStorage.getItem(storageKey)) || 0); } catch (_) {}
      try { stored = Math.max(stored, Number(sessionStorage.getItem(storageKey)) || 0); } catch (_) {}
      return stored;
    };
    const markSeen = () => {
      memoryStamp = Date.now();
      try { localStorage.setItem(storageKey, String(memoryStamp)); } catch (_) {}
      try { sessionStorage.setItem(storageKey, String(memoryStamp)); } catch (_) {}
    };
    const recentlySeen = () => Date.now() - readStamp() < 7 * 24 * 60 * 60 * 1000;
    function visible(el) {
      if (!el || !el.isConnected || !el.getClientRects().length) return false;
      for (let node = el; node; node = node.parentElement) {
        if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.contentVisibility === 'hidden' || Number(style.opacity) === 0) return false;
        if (node.tagName === 'DETAILS' && !node.open) {
          const summary = [...node.children].find(child => child.tagName === 'SUMMARY');
          if (!summary || (el !== summary && !summary.contains(el))) return false;
        }
      }
      return true;
    }
    const otherDialogOpen = () => [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],cart-drawer.active,.drawer.active,details[open].menu-opening')].some(el => !root.contains(el) && visible(el));
    const paymentInteracting = () => otherDialogOpen() || !!document.activeElement?.closest('form[action*="/cart"],cart-drawer,.cart-drawer,.cart__footer,.shopify-payment-button');
    const focusable = dialog => [...dialog.querySelectorAll('button,a[href],input,[tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && visible(el));
    function setBackgroundBlocked(blocked) {
      if (blocked) {
        if (hiddenOverflow === null) hiddenOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        for (const el of document.body.children) {
          if (el === root || el.contains(root) || ['SCRIPT','STYLE'].includes(el.tagName)) continue;
          if (!previousInert.has(el)) previousInert.set(el, el.inert);
          el.inert = true;
        }
      } else {
        for (const [el, value] of previousInert) if (el.isConnected) el.inert = value;
        previousInert.clear();
        if (hiddenOverflow !== null) document.body.style.overflow = hiddenOverflow;
        hiddenOverflow = null;
      }
    }
    function openWelcome(surface = 'trigger', automatic = false) {
      if (automatic && (recentlySeen() || autoOpened || applied() || config.knownReturning || isCartPage || hasCompetingDiscount() || paymentInteracting() || Date.now() < pauseAutoUntil)) return false;
      if (otherDialogOpen() && automatic) return false;
      updateDiscountLink();
      lastFocus = document.activeElement;
      $('ow-panel').hidden = false;
      $('ow-terms-panel').hidden = true;
      activeDialog = $('ow-dialog');
      $('ow-trigger').hidden = true;
      setBackgroundBlocked(true);
      activeDialog.focus();
      markSeen();
      if (automatic) autoOpened = true;
      emit('view', surface);
      return true;
    }
    function restoreFocus(target) {
      if (target?.isConnected && visible(target) && target.matches('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')) {
        target.focus();
        if (document.activeElement === target) return;
      }
      const fallback = [$('ow-trigger'), $('ow-announcement-open')].find(el => visible(el) && !el.disabled);
      if (fallback) fallback.focus();
    }
    function closeWelcome() {
      $('ow-panel').hidden = true;
      activeDialog = null;
      markSeen();
      setBackgroundBlocked(false);
      updateTrigger();
      restoreFocus(lastFocus);
    }
    function openTerms() {
      termsFocus = document.activeElement;
      termsFromWelcome = !$('ow-panel').hidden;
      $('ow-panel').hidden = true;
      $('ow-terms-panel').hidden = false;
      $('ow-trigger').hidden = true;
      activeDialog = $('ow-terms-dialog');
      setBackgroundBlocked(true);
      activeDialog.focus();
    }
    function closeTerms() {
      $('ow-terms-panel').hidden = true;
      if (termsFromWelcome) {
        $('ow-panel').hidden = false;
        activeDialog = $('ow-dialog');
        (termsFocus?.isConnected ? termsFocus : activeDialog).focus();
      } else {
        activeDialog = null;
        setBackgroundBlocked(false);
        updateTrigger();
        restoreFocus(termsFocus);
      }
    }
    function isWelcomeAllocation(allocation) {
      const app = allocation?.discount_application || allocation;
      return app?.target_type !== 'shipping_line' && app?.type === 'discount_code' && String(app?.title || app?.code || '').toUpperCase() === code.toUpperCase() && Number(allocation?.amount ?? app?.total_allocated_amount ?? 0) > 0;
    }
    function applied() {
      if (!cart) return false;
      return (cart.cart_level_discount_applications || []).some(isWelcomeAllocation) || (cart.items || []).some(item => [...(item.line_level_discount_allocations || []), ...(item.discount_allocations || [])].some(isWelcomeAllocation));
    }
    function isCompetingMerchandiseAllocation(allocation) {
      const app = allocation?.discount_application || allocation;
      const amount = Number(allocation?.amount ?? app?.total_allocated_amount ?? 0);
      return app?.target_type !== 'shipping_line' && amount > 0 && !isWelcomeAllocation(allocation);
    }
    function hasCompetingDiscount() {
      if (!cart) return false;
      return (cart.cart_level_discount_applications || []).some(isCompetingMerchandiseAllocation) || (cart.items || []).some(item => [...(item.line_level_discount_allocations || []), ...(item.discount_allocations || [])].some(isCompetingMerchandiseAllocation));
    }
    function cartMessage() {
      if (!cart) return `${offerReminder()} ${text.checkout_confirms}`;
      if (applied()) return text.applied;
      if (hasCompetingDiscount()) return text.competing;
      const hasProducts = (cart.items || []).some(item => Number(item.quantity || 0) > 0);
      if (!hasProducts) return text.empty_cart;
      return `${offerReminder()} ${text.checkout_confirms}`;
    }
    function makeReminder(kind) {
      const el = document.createElement('aside');
      el.className = 'ow-reminder';
      el.dataset.owOwned = 'true';
      el.dataset.owReminder = kind;
      el.setAttribute('aria-label', text.welcome_offer);
      if (config.preview) { const badge = document.createElement('span'); badge.className = 'ow-preview-label'; badge.textContent = text.preview_label; el.append(badge); }
      const message = document.createElement('p'); message.dataset.owMessage = ''; el.append(message);
      if (kind === 'product') {
        const compact = document.createElement('p');
        compact.className = 'ow-product-message-compact';
        compact.textContent = text.reminder_compact;
        el.append(compact);
      }
      const actions = document.createElement('div'); actions.className = 'ow-reminder-actions';
      const claim = document.createElement('button'); claim.type = 'button'; claim.className = 'ow-text-button'; claim.textContent = text.view_welcome_offer; claim.addEventListener('click', () => openWelcome(kind));
      if (kind === 'product') {
        claim.setAttribute('aria-label', text.view_welcome_offer);
        claim.textContent = '';
        const longLabel = document.createElement('span'); longLabel.className = 'ow-action-long'; longLabel.textContent = text.view_welcome_offer;
        const shortLabel = document.createElement('span'); shortLabel.className = 'ow-action-short'; shortLabel.textContent = text.offer;
        claim.append(longLabel, shortLabel);
      }
      const terms = document.createElement('button'); terms.type = 'button'; terms.className = 'ow-text-button'; terms.textContent = text.offer_terms; terms.addEventListener('click', openTerms);
      terms.classList.add('ow-reminder-terms');
      actions.append(claim, terms); el.append(actions); return el;
    }
    function placeReminders() {
      if (Number(config.productId) > 0 && !config.productIsGiftCard && config.productRequiresShipping !== false) {
        const form = document.querySelector('product-info product-form, .product__info-container product-form, [data-product-form], main form[action*="/cart/add"]');
        if (form && !document.querySelector('[data-ow-reminder="product"]')) form.insertAdjacentElement('afterend', makeReminder('product'));
      }
      const drawer = document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .cart-drawer__footer');
      if (drawer && !drawer.querySelector('[data-ow-reminder="drawer"]')) drawer.prepend(makeReminder('drawer'));
      const cartFooter = isCartPage && (document.querySelector('#main-cart-footer .cart__blocks') || document.querySelector('main .cart__footer') || document.querySelector('#main-cart-footer .page-width'));
      if (cartFooter && !cartFooter.querySelector('[data-ow-reminder="cart"]')) cartFooter.prepend(makeReminder('cart'));
      updateReminders();
    }
    function updateReminders() {
      for (const el of document.querySelectorAll('[data-ow-reminder]')) {
        const message = el.dataset.owReminder === 'product' ? offerReminder() : cartMessage();
        const messageElement = el.querySelector('[data-ow-message]');
        if (messageElement.textContent !== message) messageElement.textContent = message;
      }
      updateTrigger();
      updateDiscountLink();
    }
    function updateTrigger() { $('ow-trigger').hidden = !!activeDialog || otherDialogOpen(); }
    async function readCart() {
      if (fetchBusy) { refetchNeeded = true; return; }
      fetchBusy = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const next = await response.json();
        if (next.currency && next.currency !== 'AUD') {
          cart = null;
          if (activeDialog) { $('ow-panel').hidden = true; $('ow-terms-panel').hidden = true; activeDialog = null; setBackgroundBlocked(false); }
          root.hidden = true;
          document.querySelectorAll('[data-ow-reminder]').forEach(el => { el.hidden = true; });
          return;
        }
        const wasApplied = applied(); cart = next; updateReminders();
        if (applied() && !wasApplied) emit('applied', 'cart');
      } catch (_) { cart = null; updateReminders(); }
      finally { clearTimeout(timeout); fetchBusy = false; if (refetchNeeded) { refetchNeeded = false; scheduleCart(); } }
    }
    function scheduleCart(delay = 450) { clearTimeout(fetchTimer); fetchTimer = setTimeout(readCart, delay); }
    function schedulePlacement() { clearTimeout(placementTimer); placementTimer = setTimeout(placeReminders, 160); }
    function initText() {
      document.querySelectorAll('[data-ow-preview]').forEach(el => { el.hidden = !config.preview; });
      $('ow-preview-application').hidden = !config.preview;
      updateDiscountLink();
      const terms = $('ow-terms-content');
      const add = (tag, value) => { const el = document.createElement(tag); el.textContent = value; terms.append(el); };
      if (config.preview) add('p', text.preview_terms);
      add('h3', text.who_title);
      add('p', text.who);
      add('h3', text.covers_title);
      add('p', text.covers);
      add('h3', text.using_title);
      add('p', text.using);
      add('h3', text.delivery_title);
      if (config.shippingVerified) add('p', text.delivery.replace('__OW_THRESHOLD__', cash(Number(config.shippingThresholdCents))));
      add('p', String(config.shippingTerms));
      add('p', text.returns);
      const links = document.createElement('p');
      for (const [label, linkPath] of [[text.shipping_policy,'policies/shipping-policy'],[text.refund_policy,'policies/refund-policy'],[text.privacy_policy,'policies/privacy-policy']]) {
        const a = document.createElement('a'); a.href = rootUrl + linkPath; a.textContent = label; a.className = 'ow-link';
        if (links.childNodes.length) links.append(document.createTextNode(' · '));
        links.append(a);
      }
      terms.append(links);
      add('h3', text.privacy_title);
      add('p', text.privacy);
    }
    $('ow-announcement-open').addEventListener('click', () => openWelcome('announcement'));
    $('ow-trigger').addEventListener('click', () => openWelcome('trigger'));
    root.querySelectorAll('[data-ow-close]').forEach(button => button.addEventListener('click', closeWelcome));
    root.querySelectorAll('[data-ow-terms]').forEach(button => button.addEventListener('click', openTerms));
    $('ow-terms-close').addEventListener('click', closeTerms);
    $('ow-panel').addEventListener('click', e => { if (e.target === $('ow-panel')) closeWelcome(); });
    $('ow-terms-panel').addEventListener('click', e => { if (e.target === $('ow-terms-panel')) closeTerms(); });
    $('ow-discount-link').addEventListener('click', event => {
      updateDiscountLink();
      if (config.preview || applied() || hasCompetingDiscount()) {
        event.preventDefault();
        return;
      }
      markSeen();
      emit('claim', 'panel');
    });
    document.addEventListener('keydown', e => {
      if (!activeDialog) return;
      if (e.key === 'Escape') { e.preventDefault(); activeDialog === $('ow-terms-dialog') ? closeTerms() : closeWelcome(); return; }
      if (e.key !== 'Tab') return;
      const elements = focusable(activeDialog), first = elements[0], last = elements[elements.length - 1];
      if (!elements.length) { e.preventDefault(); activeDialog.focus(); }
      else if (e.shiftKey && (document.activeElement === first || document.activeElement === activeDialog)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || document.activeElement === activeDialog)) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('pointerdown', e => { if (e.target.closest('input,select,textarea,button,a,form,cart-drawer,[role="dialog"]')) pauseAutoUntil = Date.now() + 20000; }, { passive: true });
    document.addEventListener('submit', e => { if (e.target.matches('form[action*="/cart"]')) { scheduleCart(1000); setTimeout(() => scheduleCart(0), 2200); } }, true);
    document.addEventListener('change', e => { if (e.target.closest('cart-items,cart-drawer,.cart,form[action*="/cart"]')) scheduleCart(700); });
    document.addEventListener('click', e => { if (e.target.closest('cart-remove-button,quantity-input,.quantity__button,[href*="/cart/change"]')) scheduleCart(850); }, { passive: true });
    for (const event of ['cart:updated','cart:refresh','cart:change','product:added']) document.addEventListener(event, () => scheduleCart());
    window.addEventListener('pageshow', () => scheduleCart(50));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleCart(50); });
    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        if (record.target.nodeType === 1 && (root.contains(record.target) || record.target.closest?.('[data-ow-owned]'))) return false;
        if (record.type === 'attributes') return !!record.target.matches?.('cart-drawer,.drawer,dialog,[role="dialog"],details');
        return [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && node !== root && !node.matches?.('[data-ow-owned]'));
      });
      if (relevant) { schedulePlacement(); scheduleCart(); }
    });
    initText(); placeReminders(); readCart();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','open','hidden','aria-modal'] });
    if (!isCartPage && !recentlySeen() && !config.knownReturning) {
      autoTimer = setTimeout(function tryAuto() {
        if (autoOpened || recentlySeen() || applied()) return;
        if (document.hidden || !openWelcome('automatic', true)) autoTimer = setTimeout(tryAuto, 5000);
      }, 12000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountOrdessaWelcome, { once: true });
  else mountOrdessaWelcome();
  })();
  } catch(e) { console.error(e); }
})();

})();
